import { useState, useEffect } from "react";

import Hero from "./Hero/Hero";
import History from "./History/History";
import Vision from "./Vision/Vision";
import Commitment from "./Commitment/Commitment";
import Statistics from "Pages/Home/Statistics/Statistics";
import Map from "Pages/Home/Map/Map";

import LoadingScreen from "Components/RequestHandler/LoadingScreen";
import IsError from "Components/RequestHandler/IsError";
import useFetch from "Hooks/useFetch.js";

const About = () => {
  const [data, setData] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const { fetchData, error } = useFetch();

  const getData = async () => {
    setIsLoading(true);
    setIsError(false);

    try {
      const data = await fetchData("company-profiles");
      setData(data);
    } catch (error) {
      setIsError(true);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getData();
  }, []);
  if (isLoading) return <LoadingScreen />;
  if (error || isError) return <IsError />;
  if (data) {
    return (
      <main>
        <Hero data={data?.hero} />
        <History data={data?.history} />
        <Vision data={data?.our_vision} />
        <Commitment data={data?.commitment} />
        {/* <Brands data={data?.our_companies} /> */}
        <Statistics data={data?.statistics} />
        <Map />
      </main>
    );
  }
};

export default About;
